import React from "react";

import { Modal } from "src/design-system/Modal";
import { UnpublishedCaseTemplatesList } from "src/flow/modals/UnpublishedCaseTemplatesList";
import { UnpublishedTemplateDependency } from "src/flow/usePublishFlowVersionCallback";

export type UnpublishedCaseTemplatesModalProps = {
  open: boolean;
  onClose: () => void;
  afterLeave: () => void;
  unpublishedTemplates: UnpublishedTemplateDependency[] | undefined;
};

export const UnpublishedCaseTemplatesModal: React.FC<
  UnpublishedCaseTemplatesModalProps
> = ({ open, onClose, afterLeave, unpublishedTemplates }) => {
  return (
    <Modal afterLeave={afterLeave} open={open} onClose={onClose}>
      <Modal.Header description="All case template versions used by this Decision Flow version must be published before publishing this version.">
        Cannot publish version
      </Modal.Header>
      <Modal.Content>
        {unpublishedTemplates && unpublishedTemplates.length > 0 && (
          <UnpublishedCaseTemplatesList
            unpublishedTemplates={unpublishedTemplates}
          />
        )}
      </Modal.Content>
      <Modal.Footer primaryButton={false} secondaryButton="Cancel" />
    </Modal>
  );
};
